export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://kbtrans.eu').replace(/\/$/, '');
export const DEFAULT_LOCALE = 'en';
export const LOCALES = [
  { code: 'en', name: 'English', flag: '🇬🇧', ogLocale: 'en_GB' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', ogLocale: 'de_DE' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', ogLocale: 'fr_FR' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱', ogLocale: 'pl_PL' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹', ogLocale: 'it_IT' }
];

export const PAGES = [
  { key: 'home', path: '/', label: 'nav.home' },
  { key: 'services', path: '/services', label: 'nav.services', service: true },
  { key: 'destinations', path: '/destinations', label: 'nav.destinations' },
  { key: 'cargo', path: '/cargo', label: 'nav.cargo', service: true },
  { key: 'whyUs', path: '/why-us', label: 'nav.whyUs' },
  { key: 'relocations', path: '/relocations', label: 'nav.relocations', service: true },
  { key: 'privacy', path: '/privacy', label: 'privacy.title' },
  { key: 'terms', path: '/terms', label: 'terms.title' },
  { key: 'carriageTerms', path: '/carriageTerms', label: 'carriageTerms.title' }
];

// English keeps its existing URLs. Other languages have their own path prefix.
export function parseLocalePath(pathname) {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  const firstSegment = normalized.split('/')[1];
  const hasPrefix = LOCALES.some(({ code }) => code === firstSegment);
  const locale = hasPrefix ? firstSegment : DEFAULT_LOCALE;
  const pagePath = hasPrefix ? normalized.slice(firstSegment.length + 1) || '/' : normalized;
  return { locale, pagePath, page: PAGES.find(({ path }) => path === pagePath) };
}

export function localizePath(target, locale = DEFAULT_LOCALE) {
  if (!target.startsWith('/') || target.startsWith('//')) return target;
  const [, pathname, suffix = ''] = target.match(/^([^?#]*)(.*)$/);
  const { pagePath } = parseLocalePath(pathname);
  const prefix = locale === DEFAULT_LOCALE ? '' : `/${locale}`;
  return `${prefix}${pagePath === '/' ? (prefix ? '' : '/') : pagePath}${suffix}`;
}

export const pageUrl = (path, locale) => `${SITE_URL}${localizePath(path, locale)}`;
